module.exports = __webpack_public_path__ + "img/signal-2.cce5c8a8.svg";